import styled from "styled-components";
import { Button } from "@mui/material";

export const MaterialRequestWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
    height: 100%;
`;

export const StyledButton = styled(Button)`
    && {
        padding-top: 8px;
        padding-bottom: 8px;
        display: flex;
        justify-content: center;
        gap: 4px;
    }

    &.MuiButton-startIcon {
        color: #ffffff;
    }
`;

export const DoubleColumnWrapper = styled.div`
    overflow: hidden;
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 24px;
    height: auto;
    width: 100%;
`;

export const SecondColumn = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    gap: 24px;
`;

export const SummaryPanel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
    font-family: Noto Sans;
`;

export const SummaryRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
`;

export const SummaryLabel = styled.span`
    font-weight: 700;
`;

export const SummaryDivider = styled.span`
    margin: 0;
`;

export const QuantityBubble = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 999px;
    background-color: #f0f2f5;
    color: #333739;
    font-size: 12px;
    line-height: 16px;
    font-weight: 600;
    margin-left: 6px;
`;